import WrapperProvider from "@providers/WrapperProvider";
import OfferDetailContainer from "@containers/OfferDetailContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import _ from "lodash";
import Layout from "@components/Layout";
import { getServer } from "@translations/next";
import OfferService from "@services/OfferService";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";

export default function OfferDetail(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <OfferDetailContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}
export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  const pageId = "offer-detail";
  const slug = _.get(params, "slug");
  StrapiService.set("id", "hotel65-stay-connected");
  const res = await StrapiService.find({
    populate: "deep",
    locale,
  });
  const resOffer = await OfferService.find({
    filters: {
      slug: {
        $eq: slug,
      },
    },
    populate: "deep",
    locale,
  });
  if (_.isEmpty(_.get(resOffer, "data.0"))) {
    const resOfferNoLocale = await OfferService.find({
      filters: {
        slug: {
          $eq: slug,
        },
        hotel: {
          slug: {
            $eq: "amanaki-boutique-saigon",
          },
        },
      },
      locale: "all",
      populate: "deep",
    });
    if (_.isEmpty(_.get(resOfferNoLocale, "data.0"))) {
      return {
        redirect: {
          destination: "/",
          permanent: false,
        },
      };
    } else {
      const slug = _.get(
        resOfferNoLocale,
        "data.0.attributes.localizations.data.0.attributes.slug"
      );
      return {
        redirect: {
          destination: slug
            ? `/${locale}/amanaki-boutique-saigon/offers/${slug}`
            : "/",
          permanent: true,
        },
      };
    }
  }
  const resOtherOffers = await OfferService.find({
    filters: {
      slug: {
        $ne: slug,
      },
      hotel: {
        slug: {
          $eq: "amanaki-boutique-saigon",
        },
      },
    },
    populate: "deep",
    locale,
    page: 1,
    pageSize: 2,
  });
  const footerData = await FooterService.fetchByHotel("amanaki-boutique-saigon", locale);
  const result: any = {
    hotel: "amanaki-boutique-saigon",
    pageId,
    pageData: {
      attributes: { stayConnected: _.get(res, "data.attributes", {}) },
      metatags: _.get(resOffer, "data.0.attributes.metatags", {}),
    },
    offer: _.get(resOffer, "data.0", {}),
    otherOffers: _.get(resOtherOffers, "data", []),
    footerData,
  };
  if (_.isEmpty(_.get(resOffer, "data.0"))) {
    result.redirect = {
      destination: "/",
      permanent: false,
    };
  }
  return result;
});
